import { Component } from '@angular/core';

import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';
import { L10nService } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'one-time-events';

  public environment: any;

  constructor(titleService: Title, l10nService: L10nService) {
    this.environment = environment;

    titleService.setTitle(l10nService.get('app_page_title') + ' | ' + environment.societyName);
  }
}
